export const environment = {
  production: true,
  env: 'preprod',
};
